import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import api from '../config/api';
import { toast } from 'react-toastify';
import { FiCheckCircle } from 'react-icons/fi';
import LoadingSpinner from '../components/LoadingSpinner';

const PaymentSuccess = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [processing, setProcessing] = useState(true);

  useEffect(() => {
    handlePaymentSuccess();
  }, []);

  const handlePaymentSuccess = async () => {
    const paymentId = searchParams.get('paymentId');
    const payerId = searchParams.get('PayerID');
    const bookingId = searchParams.get('bookingId');

    if (!paymentId || !payerId || !bookingId) {
      toast.error('Invalid payment parameters');
      navigate('/dashboard');
      return;
    }

    try {
      // Execute payment
      await api.post('/payments/execute', { paymentId, payerId });

      // Confirm booking
      await api.put(`/bookings/${bookingId}/confirm`, { paymentId });

      toast.success('Payment successful! Your booking is confirmed.');
      setTimeout(() => {
        navigate('/dashboard');
      }, 3000);
    } catch (error) {
      console.error('Payment error:', error);
      toast.error('Payment processing failed');
      navigate('/dashboard');
    } finally {
      setProcessing(false);
    }
  };

  if (processing) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <LoadingSpinner size="large" />
          <p className="mt-4 text-lg text-gray-600">Processing your payment...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4">
      <div className="max-w-md w-full">
        <div className="bg-white rounded-2xl shadow-xl p-8 text-center">
          <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <FiCheckCircle className="text-5xl text-green-500" />
          </div>
          <h1 className="text-3xl font-bold text-gray-900 mb-4">Payment Successful!</h1>
          <p className="text-gray-600 mb-8">
            Your booking has been confirmed. You'll receive a confirmation email with all the details including the Zoom link.
          </p>
          <div className="space-y-3">
            <button
              onClick={() => navigate('/dashboard')}
              className="w-full bg-gradient-to-r from-primary-500 to-secondary-500 text-white py-3 rounded-lg font-semibold hover:shadow-lg transition"
            >
              Go to Dashboard
            </button>
            <button
              onClick={() => navigate('/booking')}
              className="w-full bg-gray-100 text-gray-700 py-3 rounded-lg font-semibold hover:bg-gray-200 transition"
            >
              Book Another Session
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;

